// General includes
import setup from '__setup/setup.js'

const UECompose = function () {
  setup()
}

export default UECompose
